import { Suspense, useContext, useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material/';
import { ToolContext } from '../../../core/context/ToolContext';
import { SnakeLoader } from '../../../core/loader/SnakeLoader';
import { BizLogo } from '../../../core/global/Icons';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { UsageComponents } from './usageOverview/UsageComponents';

export const Index = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state

    const urlParams = new URLSearchParams(window.location.search);
    let qsp = JSON.parse(urlParams.get('qsp'))
    
    const __init = async() => {
        let ainfo = await rqx.get(`<<global>>/${env()}/account/read`, {aid: qsp.aid})
        let pinfo = await rqx.get(`<<global>>/${env()}/primeinfo/read`, {aid: qsp.aid})
        let uaccess = await rqx.get(`<<global>>/${env()}/roleaccess/uap`, {aid: qsp.aid, tid:parseInt(process.env.REACT_APP_TID_BIZ)})
        
        await tool_state.__SESSION.set({ainfo, pinfo, uaccess})
        await tool_state.prefetch.set(true)
    }

    useEffect(() => {
        __init()
        // eslint-disable-next-line 
    }, [])

    return (
        <Box component={Container} width="100%" height="100%">
            {
                tool_state.prefetch.data ? (
                    <Router>
                        <Suspense fallback={
                            <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                <BizLogo size={60}/>
                                <Box pt={4}>
                                    <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
                                </Box>
                            </Box>
                        }>
                            <Switch>
                                <Box height="100%" display="flex" flexDirection="column" gap="32px">
                                    <Box minHeight="30px"></Box>
                                    <Box minHeight="50px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={1}>
                                        <Typography fontWeight={600} fontSize={32} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Usage Overview</Typography>
                                        {qsp.assigned_id === 0 ?
                                            <Typography fontWeight={400} fontSize={24} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{__SESSION.data.pinfo[0].last_name}, {__SESSION.data.pinfo[0].first_name} {__SESSION.data.pinfo[0].middle_name}</Typography>
                                        :   
                                            <Typography fontWeight={400} fontSize={24} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{qsp.last_name}, {qsp.first_name} {qsp.middle_name}</Typography>
                                        }
                                    </Box>
                                    <Route render={props=>(<UsageComponents vldt="no-access" __SESSION={__SESSION} toolOwned={[]} graphDatasets={{data:qsp}} interval={qsp.interval} />)} />
                                    <Box minHeight="50px"></Box>
                                </Box>
                            </Switch>
                            
                        </Suspense>
                    </Router>
                ) : (
                    <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                        <BizLogo size={60}/>
                        <Box mt={4}>
                            <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
                        </Box>
                    </Box>
                )
            }
        </Box>
    )
}